import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { ProgressIndicator, ProgressStep } from 'carbon-components-react';

const ProgressBar = ({ currentStep, steps }) => {
  return steps ? (
    <div css={styles.progressWrapper}>
      <ProgressIndicator currentIndex={steps.indexOf(currentStep)} spaceEqually={true}>
        {steps.map((step, i) => (
          <ProgressStep key={`${step.key}-${i}`} label={step.key} />
        ))}
      </ProgressIndicator>
    </div>
  ) : null;
};

const styles = {
  progressWrapper: css`
    inline-size: 75%;
    block-size: 0.5rem;

    .bx--progress-label {
      /* Only show the label to screen readers */
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0 0 0 0);
      border: 0;
    }
    .bx--progress-line {
      height: 8px;
      min-width: unset !important;
    }
    .bx--progress-step {
      min-width: unset !important;
      width: unset !important;
    }
    svg {
      display: none;
    }
  `,
};

ProgressBar.propTypes = {
  currentStep: PropTypes.func.isRequired,
  steps: PropTypes.array.isRequired,
};

export default ProgressBar;
